import CircleBlank from '@doltech/ui/lib/figma/BlankEditor/ViewTest/CircleBlank';
import { withStoreRequiredForOnlineTestEditor } from '@doltech/ui/lib/figma/BlogEditor/core/withStoreRequiredForOnlineTestEditor';
import { DolEditor } from '@doltech/ui/lib/figma/DolEditor/DolEditor';
import { EDITABLE_BLANK_VOID } from '@doltech/ui/lib/figma/DolEditor/elements/editable-blank-voids/types';
import { tableDatav1ToV2 } from '@doltech/ui/lib/figma/DolEditor/elements/table-blog/transforms/tableV1ToV2';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { compose } from '@doltech/utils/lib/compose';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleAnswerMain } from '../../../student-do-test-questions/SingleAnswer';
import { useTableCompletionPluginAndEditorChains } from '../../../student-do-test-questions/useTableCompletionPluginAndEditorChains';
import { DoTestTableCompletionInstance } from '../../../student-do-test/model/Question/do-test-table-completion.store';
import { Heading } from './ViewTestCompetionNoHint';

export interface ViewTestTableCompletionProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestTableCompletionInstance;
  isPdfContent: boolean;
}

const Main = styled(SingleAnswerMain)`
  font-size: 16px;
  padding: 16px;

  @media ${deviceBreakpoints.fromTablet} {
    padding: 24px;
  }

  .read-only table {
    table-layout: fixed;
    width: unset !important;
  }
`;

export const ViewTestTableCompletion = compose(
  withStoreRequiredForOnlineTestEditor(),
  observer
)((props: ViewTestTableCompletionProps) => {
  const { data, isPdfContent, ...rest } = props;

  const editorBlanks = React.useMemo(() => {
    if (data) {
      return data.blanks.map((bl, idx) => ({ blankId: bl.id, blankIndex: idx }));
    }
    return [];
  }, [data]);
  const no = data?.no;
  const { plugins, editorChains } = useTableCompletionPluginAndEditorChains({
    editorBlanks,
    no,
    isPdfContent,
    isAdmin: false,
  });
  if (!data) return null;
  const { editorValue, question, blanks } = data;

  const newTableNode = tableDatav1ToV2(JSON.parse(editorValue));

  return (
    <Main className="dol-question single-answer" {...rest}>
      <Heading>{question}</Heading>

      <DolEditor
        initialValue={newTableNode}
        editorChains={editorChains}
        plugins={plugins}
        renderElementDeps={[blanks]}
        renderElement={[
          (renderProps) => {
            if (renderProps.element.type === EDITABLE_BLANK_VOID) {
              const blankId = renderProps.element.children[0].blankId as string;
              const blank = editorBlanks.find((bl) => bl.blankId === blankId);
              return <CircleBlank circleText={no + blank.blankIndex} />;
            }
            return undefined;
          },
        ]}
      />
    </Main>
  );
});
